module.exports = __webpack_public_path__ + "static/media/record-vinyl.de389e37.svg";